import { minBreakpoints, theme } from '@noths/polaris-client-ribbons-base';
import { mediaQuery } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

const { fonts, spacing } = theme;

export const searchHeaderWrapper = css`
  text-align: center;
  margin: 0 auto ${spacing.xl}px;
  max-width: 628px;

  ${mediaQuery(
    { min: minBreakpoints.L },
    css`
      margin: 0 auto ${spacing.sm}px;
    `,
  )};
`;

export const termPrefix = css`
  font-family: ${fonts.PRIMARY_SEMIBOLD.family};
  font-weight: ${fonts.PRIMARY_SEMIBOLD.weight};
  ${theme.responsiveText.BODY.MD};
  color: var(--neutral-black-70);
  display: block;
`;

export const term = css`
  font-family: ${fonts.PRIMARY_REGULAR.family};
  font-weight: ${fonts.PRIMARY_REGULAR.weight};
  ${theme.responsiveText.HEADING.LG};
  display: block;
`;
